import { render, staticRenderFns } from "./darenBuy.vue?vue&type=template&id=330bb3bc&scoped=true&"
import script from "./darenBuy.vue?vue&type=script&lang=js&"
export * from "./darenBuy.vue?vue&type=script&lang=js&"
import style0 from "./darenBuy.vue?vue&type=style&index=0&id=330bb3bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330bb3bc",
  null
  
)

export default component.exports